import { keyframes } from 'styled-components/macro';

export const fillAnswerPercentage = p => {
    return keyframes`
    from { 
      width: 0%;
    }
    to {
      width: ${p}%; 
    }
  `;
};
